function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.67182 8.61419C1.67182 4.3559 5.12782 0.899902 9.3861 0.899902C13.6444 0.899902 17.1004 4.3559 17.1004 8.61419C17.1004 12.8725 13.6444 16.3285 9.3861 16.3285C8.1981 16.3285 7.08725 16.0508 6.07668 15.5802L0.900391 17.0999L2.4201 11.9236C1.94953 10.913 1.67182 9.80219 1.67182 8.61419ZM6.30039 6.70899L9.45039 5.3999L12.6004 6.70899V8.67263C12.6004 10.489 11.2564 12.1875 9.45039 12.5999C7.64439 12.1875 6.30039 10.489 6.30039 8.67263V6.70899Z",
  fill: "#878793"
});

function SvgIconModerationFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModerationFilled);
export default __webpack_public_path__ + "static/media/icon-moderation-filled.4d54fa9d.svg";
export { ForwardRef as ReactComponent };